
export default function TestimonialsSection() {
  const testimonials = [
    {
      name: 'Priya Mehta',
      role: 'Interior Designer, Mumbai',
      avatar:
        'https://public.readdy.ai/ai/img_res/f06803bd5b6cedd0bc7add71601ac398.jpg',
      quote:
        'I used to spend 3 hours every week updating my Instagram, website, and PDF portfolio. Now everything syncs automatically. I just design.',
      metric: 'Saved 12+ hours/month',
    },
    {
      name: 'Arjun Kapoor',
      role: 'Architect, Bangalore',
      avatar:
        'https://readdy.ai/api/search-image?query=professional%20young%20indian%20man%20architect%20headshot%20portrait%20confident%20expression%20modern%20professional%20attire%20neutral%20background%20high%20quality%20corporate%20photo&width=100&height=100&seq=210&orientation=squarish',
      quote:
        'My scattered Canva files and Pinterest boards are now one sleek link. Clients actually say "Wow, you look so professional!"',
      metric: 'Closed 3 new clients',
    },
    {
      name: 'Neha Sharma',
      role: 'Renovation Studio, Delhi',
      avatar:
        'https://readdy.ai/api/search-image?query=professional%20young%20indian%20woman%20business%20owner%20headshot%20portrait%20warm%20smile%20modern%20professional%20attire%20neutral%20background%20high%20quality%20corporate%20photo&width=100&height=100&seq=211&orientation=squarish',
      quote:
        'The unified importer is a game-changer. I imported 50+ projects from different platforms in under 10 minutes.',
      metric: 'Published in 10 mins',
    },
    {
      name: 'Vikram Patel',
      role: 'Interior Designer, Pune',
      avatar:
        'https://readdy.ai/api/search-image?query=professional%20young%20indian%20man%20interior%20designer%20headshot%20portrait%20friendly%20smile%20modern%20casual%20professional%20attire%20neutral%20background%20high%20quality%20photo&width=100&height=100&seq=212&orientation=squarish',
      quote:
        'No more "Can you send me your portfolio?" emails. I just share one link and they see everything - projects, reviews, contact.',
      metric: 'One link, all projects',
    },
    {
      name: 'Anjali Reddy',
      role: 'Architecture Student, Chennai',
      avatar:
        'https://readdy.ai/api/search-image?query=professional%20young%20indian%20woman%20architecture%20student%20headshot%20portrait%20bright%20smile%20modern%20casual%20style%20neutral%20background%20high%20quality%20photo&width=100&height=100&seq=213&orientation=squarish',
      quote:
        'As a student, I needed something free and professional. This gave me both. My first client found me through my portfolio link!',
      metric: 'First client landed',
    },
    {
      name: 'Rohan Desai',
      role: 'Commercial Designer, Ahmedabad',
      avatar:
        'https://readdy.ai/api/search-image?query=professional%20young%20indian%20man%20commercial%20designer%20headshot%20portrait%20confident%20professional%20modern%20attire%20neutral%20background%20high%20quality%20corporate%20photo&width=100&height=100&seq=214&orientation=squarish',
      quote:
        'The real-time analytics show me exactly who viewed my work. I can follow up with warm leads immediately.',
      metric: 'Better lead tracking',
    },
  ];

  return (
    <section className="py-12 sm:py-16 lg:py-24 bg-white relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 relative z-10">
        <div className="text-center mb-10 sm:mb-16">
          <div className="inline-block px-3 sm:px-4 py-2 bg-[#35C5F0]/10 border border-[#35C5F0]/30 rounded-full text-[#35C5F0] text-xs sm:text-sm font-semibold mb-4 sm:mb-6">
            Success Stories
          </div>
          <h2 className="text-2xl sm:text-3xl lg:text-4xl xl:text-5xl font-bold text-[#2F3438] mb-4 sm:mb-6">
            What Designers Say
          </h2>
          <p className="text-base sm:text-lg lg:text-xl text-[#ABB2B9] max-w-3xl mx-auto px-4">
            Real feedback on creating and publishing portfolios effortlessly
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6">
          {testimonials.map((testimonial, index) => (
            <div
              key={index}
              className="bg-white border border-[#ABB2B9]/20 rounded-2xl p-4 sm:p-6 hover:shadow-xl hover:border-[#35C5F0]/30 transition-all duration-300"
            >
              <div className="flex items-center gap-3 sm:gap-4 mb-3 sm:mb-4">
                <img
                  src={testimonial.avatar}
                  alt={testimonial.name}
                  className="w-12 h-12 sm:w-14 sm:h-14 rounded-full object-cover border-2 border-[#35C5F0]/20 flex-shrink-0"
                />
                <div className="min-w-0">
                  <p className="font-semibold text-[#2F3438] text-sm sm:text-base truncate">
                    {testimonial.name}
                  </p>
                  <p className="text-xs sm:text-sm text-[#ABB2B9] truncate">{testimonial.role}</p>
                </div>
              </div>
              <p className="text-sm sm:text-base text-[#2F3438]/80 leading-relaxed mb-3 sm:mb-4 italic">
                &quot;{testimonial.quote}&quot;
              </p>
              <div className="inline-block px-2.5 sm:px-3 py-1 sm:py-1.5 bg-[#35C5F0]/10 rounded-full text-[10px] sm:text-xs font-semibold text-[#35C5F0]">
                {testimonial.metric}
              </div>
            </div>
          ))}
        </div>

        <div className="mt-10 sm:mt-16 grid grid-cols-2 md:grid-cols-4 gap-4 sm:gap-8">
          {[
            { value: '2K+', label: 'Active Designers' },
            { value: '50K+', label: 'Portfolio Views' },
            { value: '4.9/5', label: 'Average Rating' },
            { value: '15min', label: 'Setup Time' },
          ].map((stat, index) => (
            <div key={index} className="text-center p-3 sm:p-4">
              <div className="text-2xl sm:text-3xl lg:text-4xl font-bold text-[#2F3438] mb-1 sm:mb-2">
                {stat.value}
              </div>
              <div className="text-xs sm:text-sm text-[#ABB2B9]">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
